import anime from 'animejs';

export default {
    init() {
        const sessions = document.querySelectorAll('.sessions') as NodeListOf<Element>;
        const hash = location.hash;
        const md = 768;

        if (!sessions) return;

        const moduleButtons = document.querySelectorAll('.module-select') as NodeListOf<HTMLElement>;
        const categoryButtons = document.querySelectorAll('.category-button') as NodeListOf<HTMLElement>;

        // Remove hash in url if module filter button is clicked
        if (moduleButtons.length) {
            moduleButtons.forEach((button) => {
                button.addEventListener('click', () => {
                    const uri = window.location.toString();
                    if (uri.indexOf('#') > 0) {
                        const clean_uri = uri.substring(0, uri.indexOf('#'));
                        window.history.replaceState({}, document.title, clean_uri);
                    }
                });
            });
        }

        // Remove hash in url if category filter button is clicked
        if (categoryButtons.length) {
            categoryButtons.forEach((button) => {
                button.addEventListener('click', () => {
                    const uri = window.location.toString();
                    if (uri.indexOf('#') > 0) {
                        const clean_uri = uri.substring(0, uri.indexOf('#'));
                        window.history.replaceState({}, document.title, clean_uri);
                    }
                });
            });
        }

        function closeAccordion(accordionHead: Element, accordionBody: HTMLElement) {
            const timeline = anime.timeline({
                duration: 500,
                easing: 'easeOutQuint'
            });

            timeline.add({
                begin: () => {
                    accordionBody.removeAttribute('style');
                },
                targets: accordionBody,
                height: [accordionBody.clientHeight, 0],
                duration: 200,
                complete: () => {
                    accordionBody.classList.remove('overflow-visible');
                }
            });

            accordionBody.classList.remove('active');
            accordionHead.classList.remove('active');
        }

        function openAccordion(
            accordionHead: Element,
            accordionBody: HTMLElement,
            scrollYPos: number,
            pushHistory?: boolean,
            isInitial?: boolean
        ) {
            const timelineOpen = anime.timeline({
                duration: 500,
                easing: 'easeOutQuint'
            });

            accordionBody.removeAttribute('style');

            if (!isInitial) {
                timelineOpen.add({
                    targets: accordionBody,
                    height: [0, accordionBody.clientHeight],
                    duration: 200,
                    complete: () => {
                        if (scrollYPos > 0) {
                            window.scrollTo({
                                top: scrollYPos - (window.innerWidth < md ? 150 : 90),
                                behavior: 'smooth'
                            });
                        }

                        accordionBody.classList.add('overflow-visible');
                    }
                });
            }

            accordionBody.classList.add('active');
            accordionHead.classList.add('active');

            if (pushHistory) {
                history.pushState(null, ' ', '#' + accordionHead.id);
            }
        }

        sessions.forEach(function (session: Element) {
            const accordions = session.querySelectorAll('.schedule-accordion') as NodeListOf<HTMLElement>;
            const accordionHeads = session.querySelectorAll('.accordion-head') as NodeListOf<HTMLElement>;
            const accordionBodies = session.querySelectorAll('.accordion-body') as NodeListOf<HTMLElement>;

            // we close all accordions
            if (accordionBodies.length) {
                accordionBodies.forEach((acBody) => {
                    acBody.classList.remove('active');
                    acBody.setAttribute('style', 'display:none;');
                });
            }

            if (accordionHeads.length) {
                accordionHeads.forEach((acHead: HTMLElement) => {
                    acHead.classList.remove('active');
                });
            }

            accordions?.forEach((accordion) => {
                const scrollYPos = accordion.getBoundingClientRect().top + window.scrollY;

                const accordionHead = accordion.querySelector('.accordion-head') as HTMLElement;
                const accordionBody = accordion.querySelector('.accordion-body') as HTMLElement;

                accordionHead.addEventListener('click', function (event: Event) {
                    event.stopPropagation();
                    event.preventDefault();

                    if (accordionHead.classList.contains('active')) {
                        closeAccordion(accordionHead, accordionBody);
                    } else {
                        // close open accordions
                        const openAccordionHead = session?.querySelector('.accordion-head.active') as HTMLElement;
                        const parent = openAccordionHead?.parentElement;
                        const openAccordionBody = parent?.querySelector('.accordion-body') as HTMLElement;
                        if (openAccordionHead && openAccordionBody) {
                            closeAccordion(openAccordionHead, openAccordionBody);
                        }

                        openAccordion(accordionHead, accordionBody, scrollYPos, true);
                    }
                });
            });

            if (hash) {
                const currentActiveAccordionHead = session?.querySelector(hash) as HTMLElement;
                const parent = currentActiveAccordionHead?.parentElement;
                if (!parent) return;

                const accordionBody = parent.querySelector('.accordion-body') as HTMLElement;
                const scrollYPos = parent.getBoundingClientRect().top + window.scrollY;

                openAccordion(currentActiveAccordionHead, accordionBody, scrollYPos, false);
            } else {
                // if no hash, we open the first accordion
                const firstAccordionHead = session.querySelector('.accordion-head') as HTMLElement;
                const parent = firstAccordionHead?.parentElement;
                if (!parent) return;

                const accordionBody = parent?.querySelector('.accordion-body') as HTMLElement;

                if (firstAccordionHead && accordionBody) {
                    openAccordion(firstAccordionHead, accordionBody, 0, false, true);
                }
            }
        });
    }
};
